import feathers from '@feathersjs/feathers'
import auth from '@feathersjs/authentication-client'
import rest from '@feathersjs/rest-client'
// import socketio from '@feathersjs/socketio-client'
// import io from 'socket.io-client'
// const socket = io(apiServer, { transports: ['websocket'] })
import { iff, discard } from 'feathers-hooks-common'
import feathersVuex from 'feathers-vuex'
// import { CookieStorage } from 'cookie-storage'
const apiServer = process.env.VUE_APP_API_SERVER

const restClient = rest(apiServer)

const feathersClient = feathers()
  // .configure(socketio(socket))
  .configure(restClient.fetch(window.fetch))
  .configure(auth({ storage: window.localStorage }))
  // .configure(auth({ storage: new CookieStorage({ path: '/' }) }))
  .hooks({
    before: {
      all: [
        iff(
          context => ['create', 'update', 'patch'].includes(context.method),
          discard('__id', '__isTemp')
        )
      ]
    }
  })

export default feathersClient

const {
  makeServicePlugin,
  makeAuthPlugin,
  BaseModel,
  models,
  clients,
  FeathersVuex
} = feathersVuex(feathersClient, {
  serverAlias: 'api', // or whatever that makes sense for your project
  idField: '_id' // `id` and `_id` are both supported, so this is only necessary if you're using something else.
  // whitelist: ['$regex', '$options']
})

export {
  makeAuthPlugin,
  makeServicePlugin,
  BaseModel,
  models,
  clients,
  FeathersVuex
}

// // Setting up feathers-vuex
// const {
//   makeServicePlugin,
//   makeAuthPlugin,
//   BaseModel,
//   models,
//   FeathersVuex
// } = feathersVuex(feathersClient, {
//   serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
//   idField: '_id', // Must match the id field in your database table/collection
//   whitelist: ['$regex', '$options']
// })

// export { makeAuthPlugin, makeServicePlugin, BaseModel, models, FeathersVuex }

// // import feathers from '@feathersjs/feathers'
// // eslint-disable-next-line
// // import socketio from '@feathersjs/socketio-client'
// // import rest from '@feathersjs/rest-client'
// // import auth from '@feathersjs/authentication-client'

// // import feathers, { rest, authentication as auth } from '@feathersjs/client'

// // import io from 'socket.io-client'
// // import config, { isDev } from '@/config'
// import { CookieStorage } from 'cookie-storage'

// // import 'whatwg-fetch'
// import { fetch } from 'whatwg-fetch'
// // // import { fetch as fetchPolyfill } from 'whatwg-fetch'

// import feathers from '@feathersjs/client'
// const { rest, authentication: auth } = feathers

// // import feathersjs from '@feathersjs/client'
// // const rest = feathersjs.rest
// // const auth = feathersjs.authentication

// const apiServer = process.env.VUE_APP_API_SERVER

// // eslint-disable-next-line
// // const socket = io(apiServer, { transports: ['websocket'] })
// const restClient = rest(apiServer)

// const feathersClient = feathers()
//   .configure(restClient.fetch(fetch)) // rest
//   // .configure(socketio(socket)) // websocket
//   .configure(auth({
//     // storage: window.localStorage
//     storage: new CookieStorage({ path: '/' })
//   }))

// export default feathersClient
